import React from "react"

export default function Address({ address }) {
    return (
      <>
        {address.split(', ').map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </>
    );
}